<template>
  <footer class="hero is-dark">
    <div class="hero-body">
      <div class="container">
        <p>
          2020 Sixthsense. Copyright
          <br />
        </p>
      </div>
    </div>
  </footer>
</template>

<style scoped lang="scss">
footer {
  bottom: 0;
  width: 100%;
}

.hero {
  font-size: 15px;

  a {
    color: #fff;
  }
}
</style>

<script>
export default {
  name: "Footer"
};
</script>
